import { render, staticRenderFns } from "./Paging.vue?vue&type=template&id=3cc0cdd2&scoped=true&"
import script from "./Paging.vue?vue&type=script&lang=ts&"
export * from "./Paging.vue?vue&type=script&lang=ts&"
import style0 from "./Paging.vue?vue&type=style&index=0&id=3cc0cdd2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../boss_taobao/client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cc0cdd2",
  null
  
)

export default component.exports